<template>
  <div>
    <contract-basic-info-header
      :is-draft="isDraft"
      :isInSchedule="true"
      :schedule="schedule" />

    <contract-loan-summary
      :is-draft="isDraft"
      :schedule="schedule" />

    <d-card-header class="border-bottom flex-header">
      <ul class="ss-tabs-nav ss-tabs-nav--light no-padding">
        <li
          :class="{ active: !scheduleHistoryTabVisible}"
          @click="scheduleHistoryTabVisible = false">
          <span class="m-0">Harmonogram rat</span>
        </li>
        <li
          :class="{ active: scheduleHistoryTabVisible }"
          @click="scheduleHistoryTabVisible = true">
          <span class="m-0">Operacje na harmonogramie</span>
        </li>
      </ul>
      <d-button
        class="ml-3"
        :class="{ isLoading: exportInProgress }"
        theme="success"
        @click.prevent="exportToPdf">
        Exportuj do PDF
      </d-button>
    </d-card-header>

    <contract-installments-schedule-tab
      v-show="!scheduleHistoryTabVisible"
      :first-installment-date="schedule.first_installment_date"
      :is-changed-installments="isChangedInstallments"
      :interests-loading="interestsLoading"
      :is-schedule-terminated="!!schedule.is_terminated"
      :last-installment="lastInstallment"
      :schedule-installments="schedule.installments"
      :termination-date="schedule.terminated_date" />

    <contract-schedule-history-tab
      v-show="scheduleHistoryTabVisible"
      :schedule-history.sync="schedule.schedule_history" />
  </div>
</template>

<script>
import FileSaver from 'file-saver'
import ClientUtils from '@/utils/client';
import SsDate from '@/components/common/SsDate';
import ContractBasicInfoHeader from '@/components/client/contract-partials/basic-info/ContractBasicInfoHeader.vue';
import ContractLoanSummary from '@/components/client/contract-partials/ContractLoanSummary';
import ContractScheduleHistoryTab from '@/components/client/contract-partials/contract-schedule/ContractScheduleHistoryTab.vue';
import ContractInstallmentsScheduleTab from '@/components/client/contract-partials/contract-schedule/ContractInstallmentsScheduleTab.vue';

export default {
  name: 'ContractSchedule',
  components: {
    FileSaver,
    SsDate,
    ContractBasicInfoHeader,
    ContractLoanSummary,
    ContractScheduleHistoryTab,
    ContractInstallmentsScheduleTab
  },
  props: {
    exportInProgress: {
      default: false,
      type: Boolean
    },
    interestsLoading: {
      default: false,
      type: Boolean
    },
    isChangedInstallments: {
      default: false,
      type: Boolean
    },
    isDraft: {
      required: true,
      type: Boolean
    },
    lastInstallment: {
      default: 0,
      type: Number
    },
    schedule: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      scheduleHistoryTabVisible: false
    }
  },
  methods: {
    exportToPdf () {
      this.$bus.$emit('contract-schedule-export-pdf');
    }
  }
}
</script>